"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormContext = void 0;
const react_1 = require("react");
exports.FormContext = react_1.createContext(undefined);
//# sourceMappingURL=form-context.js.map